<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'
import { toast, ToastTypes } from '@/helpers/toast'

import UiPanel from '@/components/shared/UiPanel.vue'
import UiAvatarSelector from '@/components/shared/UiAvatarSelector.vue'
import ModalWrapper from './ModalWrapper.vue'

import { useUiState } from '../../stores/uiState'
import { useGameState } from '../../stores/gameState'

import { updatePlayer } from '@/api/table/updatePlayer'
import { useMutation } from '@tanstack/vue-query'
import { usePlayerSettings } from '@/stores/playerSettings'

const { t } = useI18n()

// const { updatePlayer } = useGameState()
const { player, roomId } = storeToRefs(useGameState())
const { avatarId } = storeToRefs(usePlayerSettings())
const {
  modals: { editAvatar }
} = useUiState()

const { mutate: updatePlayerMutation, isPending: isUpdatingPlayer } = useMutation({
  mutationFn: updatePlayer,
  onSuccess() {
    editAvatar.close()
  },
  onError(error) {
    toast({
      message: t('Errors.label.Oops'),
      details: error.message,
      icon: ToastTypes.ERROR
    })
  }
})

function closeModal(newAvatar: number) {
  avatarId.value = newAvatar.toString()
  updatePlayerMutation({
    type: 'player',
    tableId: roomId.value!,
    playerId: player.value!.playerId,
    avatarId: newAvatar.toString()
  })
}
</script>

<template>
  <modal-wrapper>
    <ui-panel class="edit-avatar__panel" title="Change Avatar" @close="editAvatar.close">
      <div>{{ $t('Compete.label.SelectYourAvatar') }}</div>
      <ui-avatar-selector
        :model-value="Number(player!.avatarId)"
        @update:model-value="closeModal($event)"
      />
    </ui-panel>
  </modal-wrapper>
</template>

<style lang="scss">
.edit-avatar {
  &__avatars {
    width: 100%;
    margin: 0 4px;
  }
}
</style>
